import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GallerySlideContent } from './gallery-data';
import { SlideConfigService } from './slide-config.service';

/**
 * Carica le slide dell'hero prima del render della home: in SSR la prima slide (elemento LCP)
 * e il suo preload sono già nell'HTML. Sul client i dati arrivano da TransferState (sincrono).
 */
export const homeSlidesResolver: ResolveFn<GallerySlideContent[]> = () => inject(SlideConfigService).load();
